import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import "./home.scss";
import "react-loading-skeleton/dist/skeleton.css";
import { fetchLegalDocs } from "../../redux/slice/legalDoc/legalAPI";

const Home = () => {
  const [listCount, setListCount] = useState();
  const [showSkeleton, setShowSkeleton] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // Get legal documents list API call
    function callLegalAPI() {
      const params = {
        orgId: "ROOT",
      };
      dispatch(fetchLegalDocs(params)).then((res) => {
        setListCount(res.data.count);
        setShowSkeleton(false);
      });
    }
    callLegalAPI();
  }, [dispatch]);

  return (
    <div className='container home-page'>
      <div className='row justify-content-center align-items-center main-page'>
        {/* Legal Documents */}
        <div className='col-md-6 mb-4 d-flex align-items-stretch'>
          <div className='card p-2'>
            <Link to='/legalDoc'>
              <div className='card-body pt-4'>
                <h2>
                  {showSkeleton ? (
                    <Skeleton
                      count={1}
                      height={60}
                      width={60}
                      circle
                      enableAnimation={true}
                    />
                  ) : (
                    listCount
                  )}
                </h2>
                <p>Legal Documents</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
